export const TipoEntradaEnum = {
    SUPPLY: 'Abastecimento',
    DONATION: 'Doação',
    COURTESY: 'Cortesia (Amostra Grátis)',
    RETURN_LOAN: 'Empréstimo (Devolução)',
    RETURN: 'Devolução',
    LOAN: 'Empréstimo',
    TRANSACTION: 'Movimentação',
    CONSIGNMENT: 'Consignação',
    STOCK_ADJUSTMENTS: 'Ajustes no Estoque',
    KIT_BUILD_MOVEMENT: 'Montagem de Kit'
};

export const TipoSaidaEnum = {
    CONSUMPTION: 'Consumo',
    SALE: 'Venda',
    DISCARD: 'Descarte',
    RETURN: 'Devolução',
    LOAN: 'Empréstimo',
    RETURN_LOAN: 'Empréstimo (Devolução)',
    TRANSACTION: 'Movimentação',
    COURTESY: 'Cortesia (Amostra Grátis)',
    PROCEDURE: 'Procedimento',
    KIT_BUILD_MOVEMENT: 'Montagem de Kit'
};

export const stockTypes = [
    { label: 'Abastecimento', value: 'SUPPLY', payable: true, provider_required: false, cost_price_required: true, sale_price_required: true, visible: true },
    { label: 'Ajustes no estoque', value: 'STOCK_ADJUSTMENTS', payable: false, provider_required: false, cost_price_required: false, sale_price_required: false, visible: true },
    { label: 'Cortesia (Amostra Grátis)', value: 'COURTESY', payable: false, cost_price_required: false, sale_price_required: false, provider_required: false, visible: true },
    { label: 'Doação', value: 'DONATION', payable: false, provider_required: false, cost_price_required: false, sale_price_required: false, visible: true },
    { label: 'Devolução', value: 'RETURN', payable: false, cost_price_required: false, sale_price_required: false, visible: true },
    { label: 'Empréstimo', value: 'LOAN', payable: false, provider_required: true, cost_price_required: true, sale_price_required: true, visible: true },
    { label: 'Montagem de Kit', value: 'KIT_BUILD_MOVEMENT', payable: false, provider_required: true, cost_price_required: true, sale_price_required: false, visible: false },
    { label: 'Empréstimo (Devolução)', value: 'RETURN_LOAN', payable: false, provider_required: true, cost_price_required: true, sale_price_required: false, visible: false },
  ];
  